import { useNavigate } from "react-router-dom";
import { fmtUsd, fmtNum } from "../lib/format";
import { TokenLogo, WatchStar, Skel, Empty } from "./common";

export default function TokenTable({ tokens, loading, testId = "token-table" }) {
  const nav = useNavigate();
  if (loading) return <Skel rows={8} h={36} />;
  if (!tokens?.length) return <Empty msg="No tokens found" />;
  return (
    <div className="overflow-x-auto" data-testid={testId}>
      <table className="w-full t-table">
        <thead>
          <tr className="border-b border-[#262626] text-left">
            <th className="w-6"></th>
            <th>Token</th>
            <th className="text-right">Price</th>
            <th className="text-right">Volume 24h</th>
            <th className="text-right">Market Cap</th>
            <th className="text-right">Holders</th>
            <th className="text-right">Total Supply</th>
            <th className="text-right">Type</th>
          </tr>
        </thead>
        <tbody>
          {tokens.map((t) => (
            <tr key={t.address} onClick={() => nav(`/token/${t.address}`)} data-testid={`token-row-${t.address}`}>
              <td onClick={(e) => e.stopPropagation()}><WatchStar type="token" id={t.address} label={t.name} sub={t.symbol} /></td>
              <td>
                <div className="flex items-center gap-2">
                  <TokenLogo symbol={t.symbol} icon={t.icon_url} size={22} />
                  <span className="font-medium text-[#F3F4F6]">{t.symbol}</span>
                  {t.is_stock && <span className="text-[9px] uppercase text-[#F59E0B] border border-[#F59E0B40] px-1 rounded-sm">Stock</span>}
                  <span className="text-[#6B7280] text-xs hidden md:inline truncate max-w-[220px]">{t.name}</span>
                </div>
              </td>
              <td className="text-right num">{t.price != null ? fmtUsd(t.price) : "—"}</td>
              <td className="text-right num text-[#9CA3AF]">{t.volume_24h ? fmtUsd(t.volume_24h) : "—"}</td>
              <td className="text-right num text-[#9CA3AF]">{t.market_cap != null ? fmtUsd(t.market_cap) : "—"}</td>
              <td className="text-right num text-[#9CA3AF]">{fmtNum(t.holders)}</td>
              <td className="text-right num text-[#6B7280]">{t.total_supply != null ? fmtNum(t.total_supply) : "—"}</td>
              <td className="text-right text-xs text-[#6B7280]">{t.type}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
